export default "__VITE_ASSET__BCCXqvkd__"